<template>
  <div class="update">
    <el-input
      type="textarea"
      :rows="2"
      v-model="content.right_word"
      :disabled="true"
    />
    <div class="cont">错误原因：{{ content.type }}</div>
    <div v-show="showSource" class="cont">正词释义：{{ docText }}</div>
    <base-table
      :maxHeight="300"
      v-if="!isMyCorrecte"
      :tableTitle="tableTitle"
      :tableData="tableData"
      @handleRow="handleRow"
    />
    <div class="btns">
      <div v-show="showSource" class="tog">
        内容来源：聚点平台现代汉语大词典
      </div>
      <el-button type="primary" size="small" @click="hanlderSave"
        >忽略并存词</el-button
      >
      <el-button type="primary" size="small" @click="handleClaer"
        >忽略</el-button
      >
      <el-button type="primary" size="small" @click="correcte">更正</el-button>
      <div class="errata-query" v-if="isMyCorrecte">
        <el-input size="small" type="text" v-model="correctText" />
        <el-button size="small" type="primary" @click="myCorrecte"
          >我要纠正</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import dlgFunc from "../textProofreading/index.js";
import {
  addThesaurus,
  addWrongThesaurus,
  getDockingDictionaries,
} from "@/api/index";
import BaseTable from "@/components/BaseTable/index";
import { List } from "echarts";
export default {
  name: "updateAdvice",
  components: {
    BaseTable,
  },
  data() {
    return {
      textarea: "",
      correctText: "",
      content: "",
      userJson: {},
      errorStatisticsData: {},
      isMyCorrecte: false,
      docText: "",
      showSource: false,
      tableTitle: [
        {
          label: "序号",
          type: "indexAndSelection",
          prop: "index",
        },
        {
          label: "原句",
          prop: "error_word",
        },
      ],
    };
  },
  computed: {
    tableData() {
      const { list = [] } = this.errorStatisticsData;
      const data = list.reduce((prev, curr) => {
        const { error_word } = curr;
        if (this.content.error_word === error_word) {
          prev.push(curr);
        }
        return prev;
      }, []);
      return data;
    },
  },
  created() {
    this.$nextTick(() => {
      const item = JSON.parse(this.$route.query.item);
      this.content = item;
      this.isMyCorrecte = item.change || false;

      const { wps, errorStatistics } = localStorage;
      this.userJson = JSON.parse(wps);
      this.errorStatisticsData = JSON.parse(errorStatistics);
      this.getParaphrase();
    });
  },
  methods: {
    // 更正
    correcte() {
      const { error_word, right_word } = this.content;
      let list = this.errorStatisticsData.list;
      let position = 0;
      let revise = [];
      let num = 0;

      list = list.reduce((prev, curr) => {
        const {
          start,
          end,
          text,
          originalSentenceStart,
          originalSentenceEnd,
          offset,
        } = curr;
        const setingStart =
          originalSentenceStart != 0
            ? originalSentenceStart + num
            : originalSentenceStart;

        if (curr.error_word == error_word) {
          const action = dlgFunc.CWps.Application.ActiveDocument.Range(
            start + position,
            end + position
          );
          const errLength = error_word.length;
          const rightLength = right_word.length;
          action.Text = right_word;
          action.HighlightColorIndex = 0;
          action.Font.ColorIndex = 0;
          position = position + (rightLength - errLength);
          if (originalSentenceStart >= originalSentenceEnd) {
            num = position + (rightLength - errLength);
          }

          revise.push({
            ...curr,
            originalSentenceStart: setingStart,
            originalSentenceText:
              text.substring(0, offset) +
              right_word +
              text.substring(offset + errLength, text.length),
          });
        } else {
          prev.push({
            ...curr,
            position,
            start: start + position,
            end: end + position,
            offset: offset + num,
            originalSentenceStart: setingStart,
            originalSentenceEnd: originalSentenceEnd + num,
          });
        }
        return prev;
      }, []);
      revise.forEach((element) => {
        const { originalSentenceText } = element;
        list = list.map((item) => {
          const { originalSentenceStart } = item;
          if (originalSentenceStart == element.originalSentenceStart) {
            return {
              ...item,
              text: originalSentenceText,
            };
          }
          return item;
        });
      });
      localStorage.setItem(
        "errorStatistics",
        JSON.stringify({
          list: list,
        })
      );
      this.close();
    },
    async myCorrecte() {
      const { error_word, start, end } = this.content;
      await addWrongThesaurus({
        wrong_word: error_word,
        right_word: this.correctText,
        context: this.correctText,
        user_code: this.userJson.user.userid,
        token: this.userJson.token,
      });
      const action = wps.Application.ActiveDocument.Range(
        start,
        end
      );
      action.Text = this.correctText;
      action.HighlightColorIndex = 0;
      action.Font.ColorIndex = 0;

      let list = this.errorStatisticsData.list;
      const active = this.content;
      console.log(list);
      list = list.reduce((prev, curr) => {
        const {
          originalSentenceStart,
          originalSentenceEnd,
          offset,
          start,
          end,
        } = curr;
        const errLength = active.error_word.length;
        const rightLength = this.correctText.length;
        const num =  rightLength - errLength;
        const newStart = originalSentenceStart > 0 ? originalSentenceStart + num : originalSentenceStart;

        if(originalSentenceStart == active.originalSentenceStart && start > active.start) {
          prev.push({
            ...curr,
            offset: offset + num,
            start: start + num,
            end: end + num,
            text: active.text.substring(0, active.offset) +
            this.correctText +
            active.text.substring(active.offset + active.error_word.length, active.text.length),
            originalSentenceEnd: originalSentenceEnd + num,
          });
        }
        if(originalSentenceStart == active.originalSentenceStart && start < active.start) {
          prev.push({
            ...curr,
            text: active.text.substring(0, active.offset) +
            this.correctText +
            active.text.substring(active.offset + active.error_word.length, active.text.length),
            originalSentenceEnd: originalSentenceEnd + num,
          });
        }
        if(originalSentenceStart > active.originalSentenceStart) {
          prev.push({
            ...curr,
            originalSentenceStart: newStart,
            originalSentenceEnd: originalSentenceEnd + num,
            start: start + num,
            end: end + num,
          });
        }
        if(originalSentenceStart < active.originalSentenceStart) {
          prev.push(curr);
        }
        return prev;
      }, []);

      localStorage.setItem(
        "errorStatistics",
        JSON.stringify({
          list: list,
        })
      );
      this.close();
    },
    // 忽略并保存
    async hanlderSave() {
      const { error_word } = this.content;
      const res = await addThesaurus({
        right_word: error_word,
        context: error_word,
        token: this.userJson.token,
      });
      if (res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: "success",
        });
        dlgFunc.CWps.PluginStorage.setItem("checkBoxErr", error_word);
        this.handleClaer();
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    // 删除标记
    handleClaer() {
      let list = this.errorStatisticsData.list;
      //  是否批量处理
      const checkBox =
        localStorage.getItem("checkBox") == "true" ? true : false;
      // 被处理过的错词
      const checkBoxErr = dlgFunc.CWps.PluginStorage.getItem("checkBoxErr");

      if (checkBox) {
        dlgFunc.CWps.PluginStorage.setItem(
          "checkBoxErr",
          this.content.error_word
        );
      } else {
        dlgFunc.CWps.PluginStorage.setItem("checkBoxErr", "");
      }
      // 清除当前标记词
      if (checkBoxErr != this.content.error_word) {
        const action_ = dlgFunc.CWps.Application.ActiveDocument.Range(
          this.content.start,
          this.content.end
        );
        action_.HighlightColorIndex = 0;
        action_.Font.ColorIndex = 0;
        const actionIndex = list.findIndex(
          (value) => value.start == this.content.start
        );
        list.splice(actionIndex, 1);
      } else {
        // 清除所有相同词标记
        list = list.reduce((prev, curr) => {
          const { error_word, start, end } = curr;
          if (this.content.error_word === error_word) {
            const action_ = dlgFunc.CWps.Application.ActiveDocument.Range(
              start,
              end
            );
            action_.HighlightColorIndex = 0;
            action_.Font.ColorIndex = 0;
          } else {
            prev.push(curr);
          }
          return prev;
        }, []);
      }
      localStorage.setItem(
        "errorStatistics",
        JSON.stringify({
          list: list,
        })
      );
      this.close();
    },
    close() {
      window.close();
    },
    // 根据辞书获取释义
    async getParaphrase() {
      const res = await getDockingDictionaries({
        word: this.content.right_word,
        token: this.userJson.user.token,
      });

      if (res) {
        const data = res.body ? JSON.parse(res.body) : "";
        const { content = [] } = data;
        if (content && content.length > 0) {
          this.docText = content[0].docText || "";
          if (this.docText) {
            this.showSource = true;
          }
        }
      }
    },
    // 点击表格某一行
    handleRow(row) {
      const { start, end } = row;
      wps.Application.Selection.SetRange(start, end);
      wps.Application.ActiveDocument.ActiveWindow.Selection.Range.Select();
    },
  },
};
</script>

<style scoped>
/* ::v-deep .el-table {
  padding: 10px;
}

::v-deep .el-table .el-table__body-wrapper {
  height: 200px;
  overflow-y: auto;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width:10px; 
  height:10px; 
  background-color:#F5F5F5;
  border-radius: 10px;
} */

.update {
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

.update > div {
  margin-bottom: 3%;
}

.cont {
  max-height: 44%;
  overflow-y: auto;
}

.btns {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
}

::v-deep textarea {
  color: black !important;
}

.errata-query {
  display: flex;
  justify-content: space-evenly;
  margin-top: 30px;
}

.errata-query ::v-deep.el-input {
  width: 70%;
}

.tog {
  padding-bottom: 10px;
}
</style>
